import React from "react";
import { Grid, Link, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { deepOrange, green } from "@material-ui/core/colors";
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        // height: 72,
        width: 300,
        textAlign: "left",
        padding: 10,
        marginBottom: 20,
        cursor: "pointer",
        "&:hover": {
            border: "1px solid blue",
        },
    },
    control: {
        padding: theme.spacing(2),
    },
    square_orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    square_green: {
        color: theme.palette.getContrastText(green[500]),
        backgroundColor: green[500],
    },
}));

export default function LinkItem(props) {
    const classes = useStyles();
    const history = useHistory();
    return (
        <Paper className={classes.paper} onClick={() => history.push(props.linkRoute)} elevation={3}>
            <Link href={props.linkRoute} style={{ textDecoration: 'none', color: "black" }}>
            <Grid container spacing={1}>
                {props.totalApp === undefined ? (
                    <Grid item xs={4} style={{ height: "78px", backgroundColor: props.bgColor, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <CircularProgress />
                    </Grid>
                ) : (<Grid item xs={4} style={{ height: "78px", backgroundColor: props.bgColor, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="caption" gutterBottom component="div">
                        Total Apps
                    </Typography>
                    <Typography variant="h5" gutterBottom component="div">
                        {props.totalApp}
                    </Typography>
                </Grid>)
                }

                <Grid className={classes.paper2} item xs={8} >
                    <Grid container spacing={1}>
                        <Grid item xs={12} style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                <Typography variant="h6" gutterBottom component="div" style={{ marginTop: "12px", marginBottom: 0, fontSize: "1.2em", textAlign: "center" }}>
                                    {props.linkText}
                                </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            </Link>
        </Paper >
    );
}
